import { styled } from '@silverstein-properties/inspirelabs-ui';

export const StyledSpan = styled('span')(() => ({
  display: 'block',
}));
